// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiModuleGroup/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiModuleGroup/getMentorRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiModuleGroup/getRow&ID=${rowID}`).then(getData);

export const create = (row) => http.post('apiModuleGroup/createMentorGroup', row).then(getData);

export const update = (row) => http.post('apiModuleGroup/edit', row).then(getData);

export const remove = (row) => http.post('apiModuleGroup/delete', row).then(getData);

export const getGroupsForm = () => http.get('apiModuleGroup/getMentorGroupsForm', { silent: true }).then(getData);

export const getGroupsFormAnswers = () => http.get('apiModuleGroup/getMentorGroupsFormAnswers', { silent:true }).then(getData);

export const submitGroupsForm = (payload) => http.post('apiModuleGroup/submitMentorGroupsForm', payload).then(getData);